// Klasa kontenera PDF — sekcje raportu mają pod nią osobny wygląd do eksportu
export const PDF_EXPORT_CLASS = 'analytic-panel-pdf-export';
